<form
	[formGroup]="invoiceForm.controls"
	(ngSubmit)="submitInvoice()"
>
	<div class="row">
		<ng-template #rt let-r="result" let-t="term">
			<ngb-highlight
				[result]="r.customerName"
				[term]="t"
			></ngb-highlight
			>,
			<ngb-highlight
				[result]="r.customerNumber"
				[term]="t"
			></ngb-highlight>
		</ng-template>
		<div class="col">
			<p>
				<label>Företag</label>
				<select
					formControlName="companyId"
					class="form-control"
					(change)="onCompanyChange($event)"
				>
					<option [value]="null" [disabled]="true">Företag</option>
					<option *ngFor="let c of companies" [value]="c.id">
						{{ c.name }}
					</option>
				</select>
			</p>
		</div>
		<div class="col">
			<p>
				<label>Kund</label>
				<input
					type="text"
					class="form-control"
					formControlName="customerName"
					[ngbTypeahead]="matchCustomers"
					[resultTemplate]="rt"
					(change)="onCustomerNameChange($event)"
					(selectItem)="selectedCustomerName($event)"
					[readonly]="!invoiceForm.controls.value.companyId"
				/>
			</p>
		</div>
		<div class="col">
			<p>
				<label>Kundnummer</label>
				<input
					type="text"
					class="form-control"
					formControlName="customerNumber"
					[readonly]="true"
				/>
			</p>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<p>
				<label>Vår referens</label>
				<input
					type="text"
					class="form-control"
					maxlength="50"
					formControlName="ourReference"/>
			</p>
		</div>
		<div class="col">
			<p>
				<label>Deras referens</label>
				<input
					type="text"
					class="form-control"
					maxlength="50"
					formControlName="yourReference"/>
			</p>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<p>
				<label>Fakturatext</label>
				<input
					type="text"
					class="form-control"
					maxlength="1024"
					formControlName="remarks"/>
			</p>
		</div>
	</div>
	<p>
		<form-state [form]="invoiceForm" workingMessage="Skapar..."></form-state>
		<input
			type="submit"
            class="form-control btn btn-primary"
			value="Skapa faktura"
			[disabled]="!invoiceForm.controls.valid || invoiceForm.working"
		/>
	</p>
</form>